import axios from "axios";

const HTTP = axios.create({
  baseURL: process.env.VUE_APP_BETTEREZ_BASE_URL + "/accounts/",
  headers: {
    "x-api-key": process.env.VUE_APP_BETTEREZ_X_API_KEY
  }
});
export default {
  getLexicons() {
    return HTTP.get("lexicons/1", {
      params: {
        accountOnly: true,
        providerId: process.env.VUE_APP_BETTEREZ_PROVIDER_ID,
        context: "websales"
      }
    });
  }
};
